import time from 'assets/icons/time-icon.svg';
import timeWhite from 'assets/icons/time-icon-white.svg';
import { Img, ImgSize } from 'shared/ui/imgStyledComponent';

type TimeIconProps = {
	size?: ImgSize;
	reverse?: boolean;
};

export const TimeIcon: React.FC<TimeIconProps> = ({ size, reverse }) => {
	return <Img role="image" src={reverse ? timeWhite : time} $size={size} />;
};
